import "./style.css";
import { GoodSudokuApp } from "./ui/app.js";

const root = document.getElementById("app");
if (root) {
  new GoodSudokuApp(root);
} else {
  document.body.textContent = "Failed to mount: #app not found.";
}
